export const IMAGES = {
  logo: "/logo-lrp.png",
  hero: "/home-luxury-lodge.png",
  celebration: "https://images.pexels.com/photos/5366465/pexels-photo-5366465.jpeg",
  arrival: "/pillar/welcome-arrival.png",
  chef: "/pillar/table-private-chef.png",
  wellness: "/pillar/restore-wellness.png",
  adventure: "/pillar/table-adventure.png",
  concierge: "/pillar/welcome-concierge.png",
  welcomeKitchen: "/pillar/welcome-pantry.png",
  tableSacred: "/pillar/table-fine-dining.png",
  restoreYoga: "/pillar/restore-yoga.png",
  restoreYin: "/pillar/restore-mobility.png",
  restoreSauna: "/pillar/restore-sauna.png",
  restoreHotStone: "/pillar/restore-massage.png",
  foodKids: "/food-kids.png",
  foodBbq: "/food-bbq.png",
  foodBurger: "/food-burger.png",
  foodPasta: "/food-pasta.png",
  foodDessert: "/food-dessert.png",
  foodWinter: "/food-winter.png",
  foodSpring: "/food-spring.png",
  foodSummer: "/food-summer.png",
  foodAutumn: "/food-autumn.png",
  foodPizza: "/food-pizza.png",
  interior: "/lodge-lounge.png",
  landscape: "/pillar/table-adventure.png",
  winter: "/pillar/table-snow-catering.png",
  summer: "/pillar/table-lake-catering.png",
  founder: "/founder-faye.png",
  guestCare: "/pillar/welcome-guestcare.png",
};

// Three brand pillars — the new spine of the site.
export const PILLARS = [
  {
    n: "01",
    tag: "Welcome",
    accent: "oxblood",
    title: "The arrival that sets the tone",
    blurb:
      "The property provides the setting. We prepare it — so every guest walks in to a calm, considered welcome.",
    items: [
      {
        name: "Arrival preparation",
        blurb: "Fires lit, lamps warm, the house exhales before your guests arrive.",
        image: "/arrival-lodge.png",
      },
      {
        name: "Concierge",
        blurb: "Transfers, reservations and every quiet detail, handled without fuss.",
        image: IMAGES.concierge,
      },
      {
        name: "Property preparation",
        blurb: "Beds turned, flowers picked, the pantry stocked to the last olive.",
        image: IMAGES.interior,
      },
      {
        name: "Pantry stocking",
        blurb: "Local artisan produce, seasonal, sourced with intent.",
        image: IMAGES.welcomeKitchen,
      },
      {
        name: "Guest care",
        blurb: "Thoughtful notes, favourite drinks, allergies quietly memorised.",
        image: IMAGES.tableSacred,
      },
    ],
    image: IMAGES.arrival,
  },
  {
    n: "02",
    tag: "Table",
    accent: "gold",
    title: "Beautiful food, thoughtfully served",
    blurb:
      "Private chefs, family dining, adventure catering and sports nutrition — seasonal menus tuned to your guests and the day ahead.",
    items: [
      {
        name: "Private chefs",
        blurb: "Award-winning chefs in your kitchen, tuned to your guests' tastes.",
        image: "/private-chef.png",
      },
      {
        name: "Fine dining",
        blurb: "Multi-course tasting menus, plated with editorial care.",
        image: IMAGES.tableSacred,
      },
      {
        name: "Family dining",
        blurb: "Comforting, generous, the kind of meal everyone remembers.",
        image: "/pillar/table-family-dining.png",
      },
      {
        name: "Adventure catering",
        blurb: "Beautifully packed meals for helicopter picnics, boat days and ridge lunches.",
        image: IMAGES.adventure,
      },
      {
        name: "Snow & mountain sports catering",
        blurb: "Warming, energy-dense fare for cold days on the mountain.",
        image: "/pillar/table-snow-catering.png",
      },
      {
        name: "Hiking, biking, golf & lake-day catering",
        blurb: "Lakeside picnics, trail lunches, on-course refreshment.",
        image: "/pillar/table-lake-catering.png",
      },
      {
        name: "Sports nutrition",
        blurb: "Performance-tuned menus for skiers, cyclists and endurance athletes.",
        image: "/pillar/table-sports-nutrition.png",
      },
      {
        name: "Recovery meals",
        blurb: "Anti-inflammatory, nutrient-dense dishes designed for real recovery.",
        image: "/pillar/table-recovery.png",
      },
    ],
    image: IMAGES.chef,
  },
  {
    n: "03",
    tag: "Restore",
    accent: "forest",
    title: "Recovery, wellness, quiet",
    blurb:
      "Private yoga, mobility work, restorative treatments and recovery nutrition — the guest leaves feeling better than they arrived.",
    items: [
      {
        name: "Private yoga",
        blurb: "One-to-one sessions with your own certified teacher, in the home or outside.",
        image: IMAGES.restoreYoga,
      },
      {
        name: "Wellness experiences",
        blurb: "Breathwork, sound healing and quiet ritual, held with expertise.",
        image: IMAGES.wellness,
      },
      {
        name: "Mobility & stretching",
        blurb: "Restorative sessions that unlock long days on skis, trails or in the water.",
        image: "/restore-yin-yoga.png",
      },
      {
        name: "Recovery nutrition",
        blurb: "Fresh, functional, delicious — nutrition that undoes the day.",
        image: "/pillar/restore-nutrition.png",
      },
      {
        name: "Post-snow & mountain sports recovery",
        blurb: "Sauna, cold plunge, and considered protocols for full recovery.",
        image: IMAGES.restoreSauna,
      },
      {
        name: "Massage & restorative treatments",
        blurb: "Deep tissue, hot-stone, myofascial release — restorative bodywork tailored to you.",
        image: IMAGES.restoreHotStone,
      },
    ],
    image: IMAGES.wellness,
  },
];

// Kept for the existing Services component compatibility (maps 1:1 to pillars).
export const SERVICES = PILLARS.map((p) => ({
  n: p.n,
  title: `${p.tag} — ${p.title}`,
  blurb: p.blurb,
  items: p.items,
  image: p.image,
}));

export const PHILOSOPHY = [
  { n: "01", line: "A beautifully prepared welcome." },
  { n: "02", line: "A table that suits the party and the season." },
  { n: "03", line: "Adventure catering that honours the day ahead." },
  { n: "04", line: "Recovery, wellness and quiet in return." },
  { n: "05", line: "One trusted partner behind every detail." },
];

export const WINTER = [
  "Après-ski grazing tables",
  "Snow & mountain sports catering",
  "Fireside recovery dinners",
  "Breakfasts before first chair",
];

export const SUMMER = [
  "Lakeside picnics & BBQs",
  "Hiking, biking, golf hampers",
  "Sunset alfresco dinners",
  "Sports nutrition & recovery meals",
];

// Who we serve
export const AUDIENCES = [
  "Lodge & retreat owners",
  "Boutique accommodation operators",
  "Premium property managers",
  "Villa & private residence managers",
  "Travel designers",
  "Destination management companies",
  "Hospitality partners",
];

// Commercial benefits for property partners.
export const COMMERCIAL_BENEFITS = [
  "One trusted local relationship",
  "Fewer suppliers to manage",
  "Flexible delivery",
  "Consistent service standards",
  "Increased guest satisfaction",
  "Premium ancillary revenue",
  "Protection of property reputation",
  "One accountable hospitality partner",
];

// Legacy — kept for old PropertyManagers section (now folded into Partners page).
export const PROPERTY_SERVICES = COMMERCIAL_BENEFITS;

export const GALLERY = [
  { url: IMAGES.landscape, label: "Cascade River", span: "row-span-2" },
  { url: IMAGES.winter, label: "Welcome", span: "" },
  { url: IMAGES.interior, label: "Restore", span: "" },
  { url: IMAGES.adventure, label: "Mt Aspiring", span: "row-span-2" },
  { url: IMAGES.chef, label: "Table", span: "" },
  { url: IMAGES.arrival, label: "The Arrival", span: "" },
];

export const JOURNAL = [
  { title: "One Trusted Hospitality Partner", tag: "Philosophy" },
  { title: "The Art of the Arrival", tag: "Welcome" },
  { title: "Food, Thoughtfully Served", tag: "Table" },
  { title: "Restore — Wellness & Recovery", tag: "Restore" },
  { title: "Snow & Mountain Sports Catering", tag: "Winter" },
  { title: "Adventure Catering for Alpine Days", tag: "Summer" },
  { title: "Partnering with Property Managers", tag: "Partners" },
  { title: "Behind the Scenes of a Great Stay", tag: "Craft" },
];

export const SERVICE_OPTIONS = [
  "Welcome — Arrival & concierge",
  "Table — Private chef & dining",
  "Table — Adventure & mountain sports catering",
  "Restore — Wellness & recovery",
  "Full-stay hospitality partnership",
  "Property manager partnership",
  "Travel designer / DMC enquiry",
  "Other",
];

// Themed comfort-food menus — for guests who want beautiful indulgence, not just wellness.
export const THEMED_MENUS = [
  {
    tag: "Kids",
    image: IMAGES.foodKids,
    note: "Wholesome food little ones actually want to eat — plated with just as much love.",
    items: [
      { name: "Home-made mac & cheese", detail: "Cavatappi pasta, sharp cheddar béchamel, buttery breadcrumb crust." },
      { name: "Mini free-range chicken meatballs", detail: "With buttery mash and rainbow honey-glazed carrots." },
      { name: "Crispy chicken tenders", detail: "Panko-crumbed free-range chicken with house tomato dip." },
      { name: "Frozen banana pops", detail: "Dipped in dark chocolate and rolled in crushed hazelnuts." },
    ],
  },
  {
    tag: "BBQ",
    image: IMAGES.foodBbq,
    note: "Long alfresco lunches on the terrace or beside the lake — generous, joyful, share-style.",
    items: [
      { name: "Char-grilled NZ lamb chops", detail: "Rosemary, garlic, aged red wine vinegar." },
      { name: "Grilled prawn skewers", detail: "Preserved lemon, chilli, herb butter." },
      { name: "Char-grilled corn cobs", detail: "Manuka honey butter, smoked paprika, lime, feta." },
      { name: "Stone fruit & halloumi salad", detail: "Charred peaches, apricots, halloumi, rocket, mint." },
    ],
  },
  {
    tag: "Burgers",
    image: IMAGES.foodBurger,
    note: "The best burger you'll ever have — grass-fed, brioche bun, hand-cut chips. Comfort at its finest.",
    items: [
      { name: "The Signature Burger", detail: "Grass-fed NZ beef, aged cheddar, streaky bacon, caramelised onion jam, pickles, house aioli, brioche bun." },
      { name: "Buttermilk fried chicken burger", detail: "Free-range chicken, slaw, house pickles, honey-mustard mayo." },
      { name: "Portobello mushroom burger", detail: "Grilled mushroom, whipped goat's cheese, rocket, truffle mayo." },
      { name: "Hand-cut kūmara & rosemary chips", detail: "With smoked aioli — the perfect side." },
    ],
  },
  {
    tag: "House-made Pasta",
    image: IMAGES.foodPasta,
    note: "Pasta made from scratch in the lodge kitchen — slow food, quietly perfect.",
    items: [
      { name: "Hand-cut pappardelle & beef ragù", detail: "Slow-braised beef, red wine, tomato, aged parmesan." },
      { name: "Ricotta & spinach ravioli", detail: "Brown butter, sage, toasted pine nuts, lemon." },
      { name: "Spaghetti alla vongole", detail: "Fresh NZ clams, garlic, chilli, parsley, white wine." },
      { name: "Cacio e pepe", detail: "Pecorino romano, cracked black pepper — the classic done right." },
    ],
  },
  {
    tag: "Dessert",
    image: IMAGES.foodDessert,
    note: "Beautiful, seasonal, always worth the last bite.",
    items: [
      { name: "Warm poached Central Otago pear", detail: "Rosemary-honey drizzle, vanilla mascarpone, hazelnut praline." },
      { name: "Dark chocolate fondant", detail: "Molten centre, salted caramel ice cream, cocoa nib crunch." },
      { name: "Manuka honey pavlova", detail: "Fresh berries, whipped cream, passionfruit, edible flowers." },
      { name: "Cheese board", detail: "NZ artisan cheeses, quince paste, walnut crackers, honeycomb." },
    ],
  },
];

// Faye Joy — Founder bio.
export const FOUNDER = {
  name: "Faye Joy",
  role: "Founder",
  summary:
    "26 years across professional cooking, luxury hospitality and functional nutrition — with 800+ hours of advanced yoga, somatic and recovery training.",
  bio: [
    "Faye trained as a professional chef in New Zealand before spending 16 years aboard luxury superyachts — cooking for international families, athletes and wellness-driven travellers.",
    "As Performance Chef for the America's Cup, she deepened her expertise in functional nutrition, sleep, recovery and nervous system regulation.",
    "Alongside her culinary career, Faye has completed 800+ hours of advanced yoga, somatic and recovery training — including trauma-informed yoga, functional anatomy, somatics, meditation, breathwork, Thai Yoga Massage and yoga-therapy foundations across the Himalayas, Costa Rica and New Zealand. She has owned two Yin Yoga centres focused on nervous system health and accessible recovery.",
    "Her approach is shaped by global experience, professional precision and a deep commitment to helping guests feel nourished, grounded and cared for.",
  ],
  media: [
    {
      label: "Award-Winning Superyacht Chef",
      publication: "Yachting Magazine",
      url: "https://www.yachtingmagazine.com/Yacht-Chefs/",
    },
    {
      label: "From luxury yacht chef to yoga instructor",
      publication: "Otago Daily Times",
      url: "https://www.google.com/search?q=Faye+Winmill+Otago+Daily+Times+luxury+yacht+chef+to+yoga+instructor",
    },
    {
      label: "Yoga chef — Afternoons Interview",
      publication: "Radio New Zealand",
      url: "https://www.google.com/search?q=Faye+Winmill+RNZ+Afternoons+yoga+chef",
    },
    {
      label: "Urban Ashrams — Take an hour out of your day to regenerate",
      publication: "Fashion Quarterly",
      url: "https://fq.co.nz/urban-ashrams-take-an-hour-out-of-your-day-to-regenerate/",
    },
  ],
};

// Brand strings — used across the site.
export const BRAND = {
  name: "Lodge & Retreat Partners",
  wordmark: ["Lodge & Retreat", "Partners"],
  philosophy: "Welcome. Table. Restore.",
  positioning:
    "Private hospitality for extraordinary properties and unforgettable stays.",
  partnerLine:
    "The trusted private hospitality partner behind extraordinary properties and unforgettable stays.",
};

// Seasonal menus — breakfast / lunch / dinner per season with healing benefits.
export const SEASONAL_MENUS = {
  Winter: {
    image: IMAGES.foodWinter,
    note: "Warming, immune-supportive and deeply restorative after a day on the mountain.",
    breakfast: [
      {
        name: "Manuka honey porridge",
        detail: "Slow-cooked steel-cut oats with poached feijoa, toasted almonds and manuka honey.",
        benefit: "Slow-release energy for the slopes, gut-healing oats, immunity-boosting manuka.",
      },
      {
        name: "Warm cinnamon buckwheat pancakes",
        detail: "Gluten-free, with lemon curd, cultured yoghurt and NZ thyme honey.",
        benefit: "Grounding grains, blood-sugar balance, live probiotics for winter gut health.",
      },
    ],
    lunch: [
      {
        name: "Bone broth lamb & root vegetable soup",
        detail: "Slow-braised Central Otago lamb, kūmara, purple carrot, thyme, hand-torn sourdough.",
        benefit: "Collagen-rich for joints, iron-rich for altitude, deeply restorative.",
      },
      {
        name: "Warm quinoa & roasted kūmara bowl",
        detail: "With walnuts, goat's feta, wilted spinach and manuka-mustard dressing.",
        benefit: "Complete plant protein, omega-3s and iron for recovery.",
      },
    ],
    dinner: [
      {
        name: "Central Otago venison",
        detail: "Pan-seared farmed venison with roasted beets, blackcurrant jus, celeriac purée.",
        benefit: "Lean protein — iron and B12 for oxygen delivery at altitude.",
      },
      {
        name: "Miso-glazed Ora King salmon",
        detail: "With charred winter greens, black rice and a preserved lemon dressing.",
        benefit: "Omega-3s to reduce inflammation and support muscle recovery.",
      },
    ],
    dessert: [
      {
        name: "Dark chocolate & manuka honey pot",
        detail: "Silky dark chocolate ganache, manuka honey, sea salt, olive oil.",
        benefit: "Flavonoids for circulation, magnesium for a calm night's sleep.",
      },
      {
        name: "Warm spiced poached quince",
        detail: "Cinnamon, star anise, vanilla mascarpone, toasted almonds.",
        benefit: "Warming spices for digestion, prebiotic fibre for gut warmth.",
      },
    ],
  },
  Spring: {
    image: IMAGES.foodSpring,
    note: "Bright, hopeful, cleansing — supporting the body as the light returns.",
    breakfast: [
      {
        name: "Poached egg on sourdough",
        detail: "Free-range egg, spring greens, edible cherry blossoms, radish shavings.",
        benefit: "Choline for brain function, folate and vitamin K from spring greens.",
      },
      {
        name: "Chia bloom bowl",
        detail: "Coconut chia with mashed strawberries, kiwifruit, mint and manuka honey.",
        benefit: "Anti-inflammatory omega-3s, vitamin C, gentle hydration for the gut.",
      },
    ],
    lunch: [
      {
        name: "Cherry-blossom asparagus tart",
        detail: "Buttery pastry, whipped goat's cheese, spring asparagus, lemon zest.",
        benefit: "Prebiotic asparagus supports the microbiome; folate for renewal.",
      },
      {
        name: "Fresh trout ceviche",
        detail: "Line-caught rainbow trout, lime, avocado, cucumber, coriander, chilli.",
        benefit: "Lean protein, healthy fats, natural detox support.",
      },
    ],
    dinner: [
      {
        name: "Herb-roasted spring lamb",
        detail: "Slow-roasted with fresh thyme, new-season potatoes and pea shoots.",
        benefit: "Grass-fed iron and zinc for immune renewal.",
      },
      {
        name: "Beetroot & horseradish gnocchi",
        detail: "Hand-rolled beetroot gnocchi with brown butter, walnuts and shaved parmesan.",
        benefit: "Nitrates for circulation, walnuts for brain health, comfort without heaviness.",
      },
    ],
    dessert: [
      {
        name: "Rhubarb & rose panna cotta",
        detail: "Silky vanilla panna cotta with poached rhubarb and rose petals.",
        benefit: "Gut-soothing gelatin, rhubarb fibre, gentle detox support.",
      },
      {
        name: "Cherry-blossom shortbread",
        detail: "Buttery shortbread with cherry compote and elderflower cream.",
        benefit: "A small joy — mindful indulgence to celebrate the light returning.",
      },
    ],
  },
  Summer: {
    image: IMAGES.foodSummer,
    note: "Fresh, bright, cooling — long alfresco days on the lake.",
    breakfast: [
      {
        name: "Central Otago stone-fruit bowl",
        detail: "Peaches, apricots, nectarines with cultured yoghurt, toasted seeds, manuka honey.",
        benefit: "Vitamin C, live probiotics, natural hydration and gut health.",
      },
      {
        name: "Smoked salmon avocado toast",
        detail: "NZ Ora King salmon on sourdough with avocado, lemon, capers, dill.",
        benefit: "Brain-boosting omega-3s, healthy fats, sustained morning energy.",
      },
    ],
    lunch: [
      {
        name: "Lake Wānaka picnic platter",
        detail: "Charcuterie, aged cheeses, marinated olives, sourdough, summer figs, cherries.",
        benefit: "Slow eating, mindfulness — good bacteria, magnesium and antioxidants.",
      },
      {
        name: "Grilled peach & rocket salad",
        detail: "Charred stone fruit with buffalo mozzarella, peppery rocket, basil, aged balsamic.",
        benefit: "Digestive enzymes, calcium, gentle anti-inflammatory herbs.",
      },
    ],
    dinner: [
      {
        name: "Grilled Ora King salmon",
        detail: "With charred stone fruit, fennel, peppery rocket and lemon-thyme dressing.",
        benefit: "Anti-inflammatory omega-3s, vitamin D, muscle recovery.",
      },
      {
        name: "Charred sourdough flatbreads",
        detail: "With heirloom tomatoes, burrata, basil oil and Central Otago olive oil.",
        benefit: "Lycopene, healthy monounsaturated fats, heart-supportive.",
      },
    ],
    dessert: [
      {
        name: "Manuka honey pavlova",
        detail: "Crisp meringue, whipped cream, fresh berries, passionfruit, edible flowers.",
        benefit: "Local honey for immunity, vitamin C from summer berries.",
      },
      {
        name: "Stone-fruit sorbet trio",
        detail: "Peach, apricot and cherry sorbet with a dark chocolate shard.",
        benefit: "Naturally sweetened, cooling, refreshing after a long alpine day.",
      },
    ],
  },
  Autumn: {
    image: IMAGES.foodAutumn,
    note: "Grounding harvest — supporting the immune system as the year turns.",
    breakfast: [
      {
        name: "Roasted apple & pear granola",
        detail: "Toasted oats, hazelnuts, seeds and honey-roasted orchard fruit with kefir.",
        benefit: "Prebiotic fibre, live probiotics, magnesium for sleep and calm.",
      },
      {
        name: "Sweet potato hash",
        detail: "Roasted kūmara, wilted greens, poached egg, chilli oil.",
        benefit: "Beta-carotene for skin and immunity, warming spices for circulation.",
      },
    ],
    lunch: [
      {
        name: "Porcini & barley risotto",
        detail: "Slow-cooked pearl barley with sautéed porcini mushrooms, thyme, aged parmesan.",
        benefit: "Beta-glucans for immunity, low-GI grain for steady afternoon energy.",
      },
      {
        name: "Roast pumpkin & lentil salad",
        detail: "Roasted pumpkin, green lentils, pomegranate, walnuts, tahini-lemon dressing.",
        benefit: "Plant iron, complete fibre, polyphenols for immune resilience.",
      },
    ],
    dinner: [
      {
        name: "Seared NZ venison",
        detail: "Farmed venison with roasted golden beets, blackberry jus, pickled walnuts, micro sorrel.",
        benefit: "Lean protein — iron, zinc and B12 for grounding at the season turn.",
      },
      {
        name: "Miso-butter roasted parsnips",
        detail: "Deep-roasted with brown miso, thyme, hazelnuts and confit garlic.",
        benefit: "Fermented miso for gut health, prebiotic garlic for immune defence.",
      },
    ],
    dessert: [
      {
        name: "Warm poached Central Otago pear",
        detail: "Rosemary-honey drizzle, vanilla mascarpone, hazelnut praline.",
        benefit: "Fibre-rich pear, healthy fats from hazelnuts, gentle sweetness.",
      },
      {
        name: "Spiced apple & walnut crumble",
        detail: "Central Otago apples, cinnamon, walnut-oat crumble, cultured cream.",
        benefit: "Grounding warming spices, omega-3s from walnuts, fibre for digestion.",
      },
    ],
  },
};
